import Grid from "@mui/material/Grid";
import { useNavigate } from "react-router-dom";
import typography from "assets/theme/base/typography";
import error404 from "assets/images/error404.png";
import { Box, Button, Typography } from "@mui/material";
import "./err.css"

export const E404Page = () => {
  const navigate = useNavigate();
  return (
      <Box my={24} height="calc(100vh - 24rem)">
        <Grid
          container
          spacing={3}
          justifyContent="center"
          alignItems="center"
          sx={{ height: "100%",width: "50%" ,textAlign:"left" ,margin:"auto" }}
          
        >
            <Grid item xs={12} lg={6}>
              <Box
                fontSize={75}
              >
                <Typography variant="h1" className="error-404-head">
                  Error 404
                </Typography>
              </Box>
              <Typography variant="h4"  sx={{fontSize:"35px",color:"rgb(41,46,79)"}}>
                You are not signed in.
              </Typography>
              <Box mt={1} mb={2}>
                <Typography variant="h5" sx={{fontSize:"23px",color:"rgb(134,140,150)"}}>
                 Please sign in to proceed.
                </Typography>
              </Box>
              <Box mt={2} mb={2} sx={{width:"30%"}}>
                <Button
                  onClick={() =>    navigate("/")}
                  className="not-signed-in-button"
                >
                  Sign in!
                </Button>
              </Box>
            </Grid>
            <Grid item xs={12} lg={6}>
              <Box component="img" src={error404} alt="error-404" width="100%" />
            </Grid>
        
        </Grid>
      </Box>
  );
};
